// 会员 type=3

import mixin from './mixin'

export default {
  mixins: [mixin],

  methods: {
    onClick () {
      this.$router.push('/vip?from=h5_shouye')
    }
  },

  render () {
    const {
      list, // from mixin
      style, // from mixin
      onClick // from this.methods
    } = this

    return (
      <section class={style.vip}>
        {
          list.map(item => {
            return (
              <div class={style.vipItem} onClick={onClick}>
                <img class='img-w' src={item.imageUrl} alt={item.number} />
              </div>
            )
          })
        }
      </section>
    )
  }
}
